<template>
	<el-header height="55px">
		<el-menu class="el-menu-demo"
			mode="horizontal">
			<el-row>
				<div class="header-wrapper"
					style="display: flex;justify-content: space-between;">
					<div>
						<a href="/"><img style=" height: 23px;margin: 17px 0 0 20px;"
								src="../../assets/img/top/logo.png" /></a>
					</div>
					<div>
						<div class="link-wrapper">
							<el-link class="link hide-when-mobile a-nav"
								href="https://medium.com/ontologynetwork/how-to-sign-up-to-run-an-ontology-node-5415ba1bb53c"
								target="_blank">
								{{ $t("footer.RunANode") }}
							</el-link>
						</div>
						<div class="link-wrapper">
							<el-link class="link hide-when-mobile a-nav"
								href="https://node.ont.io/app/node-stake"
								target="_blank">
								{{ $t("footer.StakeOnt") }}
							</el-link>
						</div>
						<div class="link-wrapper">
							<el-link class="link hide-when-mobile a-nav"
								href="https://node.ont.io/liquid-staking/"
								target="_blank">
								{{ $t("footer.stONT") }}
							</el-link>
						</div>
						<div class="link-wrapper">
							<el-link class="link hide-when-mobile a-nav"
								href="/calculator/node">
								{{ $t("footer.Calculator") }}
							</el-link>
						</div>
						<div class="link-wrapper">
							<el-link class="link hide-when-mobile a-nav"
								href="https://node-docs.ont.io/"
								target="_blank">
								{{ $t("footer.Docs") }}
							</el-link>
						</div>
						<el-dropdown @command="
								handleCommand"
							trigger="click">
							<span class="el-dropdown-link">
								<span class="title-lang">
									<img class="lang-img"
										src="../../assets/img/top/globe.png" />
									<span class="hide-when-mobile">{{ $t("language.Language") }}
									</span>
									<i class="el-icon-arrow-down el-icon--right hide-when-mobile"></i>
								</span>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="en">
									<span :class="
                      $i18n.locale == 'en' ? 'lang-active' : 'lang-noactive'
                    ">
										English
									</span>
								</el-dropdown-item>
								<el-dropdown-item command="zh">
									<span :class="
                      $i18n.locale == 'zh' ? 'lang-active' : 'lang-noactive'
                    ">
										中文
									</span>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</el-row>
		</el-menu>
	</el-header>
</template>
<script>
import { langInit, changeLang } from "utils/lang";
export default {
	computed: {
		language() {
			return this.$i18n.locale;
		},
	},
	mounted() {
		langInit(this.language);
	},
	methods: {
		handleCommand(command) {
			this.changeLanguage(command);
		},
		changeLanguage($lang) {
			this.$i18n.locale = $lang;
			changeLang(this.language);
		},
	},
};
</script>
<style>
.el-header {
	padding: 0;
	background-color: #000;
	position: fixed;
	top: 0px;
	width: 100%;
	z-index: 1001;
}
.el-header ul {
	background-color: #000;
}
.el-submenu__title {
	color: #fff;
	width: 150px;
	right: 0;
	padding-left: 10px;
	padding-right: 10px;
}
.el-submenu__title:hover {
	background-color: #6f6f6f;
}
.el-submenu__title i {
	color: #ffffff;
}
.header-title {
	color: #fff;
	font-weight: 600;
	text-align: left;
	font-size: 30px;
	line-height: 56px;
}
a:visited {
	text-decoration: none;
}
a:-webkit-any-link {
	text-decoration: none;
}
.title-lang {
	top: -5%;
	position: relative;
}
.el-menu.el-menu--horizontal {
	border-bottom: 0px;
}
.el-submenu__title:hover {
	background-color: #000000;
}
.el-menu--horizontal .el-menu .el-menu-item {
	font-family: NunitoSans-Regular, "Avenir", Helvetica, Arial, sans-serif;
}
.lang-img {
	width: 12px;
	transform: translate(-10px, 1px);
}
.link-wrapper {
	position: relative;
	height: 19px;
	top: 50%;
	display: inline-block;
	transform: translateY(-50%);
	text-align: center;
	color: #606266;
	right: 20px;
}
.link {
	font-size: 14px;
	font-weight: 700;
	line-height: 19px;
	font-family: NunitoSans-Regular, "Avenir", Helvetica, Arial, sans-serif;
}
.el-dropdown-link,
.el-dropdown-selfdefine {
	font-size: 14px;
	font-family: NunitoSans-Bold, "Avenir", Helvetica, Arial, sans-serif;
	font-weight: bold;
	color: rgba(255, 255, 255, 1);
	line-height: 19px;
}
.el-dropdown {
	top: 50%;
	transform: translateY(-50%);
}
.el-dropdown {
	cursor: pointer;
}
.lang-active {
	color: #afafaf;
}
.el-dropdown-menu__item {
	font-family: NunitoSans-Regular, "Avenir", Helvetica, Arial, sans-serif;
}
.a-nav {
	margin-right: 30px;
	color: rgba(255, 255, 255, 1);
}
</style>
